import { mockVariablesForValues } from './mockVariablesForValues';

export type TaxationOptionsResponseType =
  | 'ask-for-other'
  | 'has-access-to-real-stocks'
  | 'no-access-to-real-stocks';

export const sendAndValidateTaxationEntries = async (props: {
  taxationEntries: string[];
}): Promise<{ realStocksAccessStatus: TaxationOptionsResponseType }> => {
  const { taxationEntries } = props;

  // This function is a placeholder for sending and validating taxation entries.
  // The actual implementation will depend on the specific requirements and API endpoints.
  return new Promise((resolve, _reject) => {
    setTimeout(() => {
      if (
        !taxationEntries.some((entry) =>
          entry.includes(mockVariablesForValues.SURELY_NOT_US),
        )
      ) {
        resolve({ realStocksAccessStatus: 'no-access-to-real-stocks' });
      } else if (
        taxationEntries.some(
          (entry) =>
            entry.includes(mockVariablesForValues.AUSTRIA_OR_GERMANY_GOOD) &&
            taxationEntries.some((entry) =>
              entry.includes(mockVariablesForValues.SURELY_NOT_US),
            ),
        )
      ) {
        resolve({ realStocksAccessStatus: 'has-access-to-real-stocks' });
      } else if (
        taxationEntries.some(
          (entry) =>
            entry.includes(mockVariablesForValues.OTHER_RAX_REGION) &&
            taxationEntries.some((entry) =>
              entry.includes(mockVariablesForValues.SURELY_NOT_US),
            ),
        )
      ) {
        resolve({ realStocksAccessStatus: 'ask-for-other' });
      } else {
        resolve({ realStocksAccessStatus: 'no-access-to-real-stocks' });
      }
    }, 500);
  });
};
